import { useUiStore } from '../../store/ui';
import { MONTH_NAMES } from '../../lib/dates';
import styles from './MonthMenu.module.css';

export function MonthMenu() {
  const { month, openMenu, setMonth, setOpenMenu } = useUiStore();
  const isOpen = openMenu === 'month';
  return (
    <div className={styles.wrap}>
      <button className={styles.trigger} onClick={() => setOpenMenu(isOpen ? null : 'month')}>
        {MONTH_NAMES[month]}
        <span className={styles.caret}>▾</span>
      </button>
      {isOpen && (
        <div className={styles.menu}>
          {MONTH_NAMES.map((name, m) => (
            <button
              key={name}
              className={`${styles.pick} ${m === month ? styles.selected : ''}`}
              onClick={() => setMonth(m)}
            >
              {name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
